const THREE_ZERO_STAKE_CURRENCIES = Object.freeze(['VND', 'KHR']);
const BASE_QUICK_AMOUNTS = Object.freeze([25, 50, 75, 100]);

export function getStakeInputMultiplier(currency: string): number {
    return THREE_ZERO_STAKE_CURRENCIES.includes(currency) ? 1000 : 1;
}

export function getQuickStakeAmounts(currency: string): readonly number[] {
    const multiplier = getStakeInputMultiplier(currency);
    return BASE_QUICK_AMOUNTS.map(amount => amount * multiplier);
}

export function getZeroStakeValue(currency: string, thousandSeparator: string): string {
    return THREE_ZERO_STAKE_CURRENCIES.includes(currency)
        ? `${thousandSeparator}000`
        : '0';
}
